export default {
  methods: {
    validateThumbnailDimension(file,width,height){
      if (!file.manuallyAdded) {
          if (file.width > width || file.height > height) {
          file.rejectDimensions()
        }
        else {
          file.acceptDimensions();
        }
      }
    },
    validateBannerDimension(file,width,height){
      if (!file.manuallyAdded) {
          if (file.width < width || file.height < height) {
          file.rejectDimensions()
        }
        else {
          file.acceptDimensions();
        }
      }
    },
    showError(file,width,height,done){
      file.acceptDimensions = done;
      file.rejectDimensions = () => { done("Invalid dimensions. Please upload a photo of "+width+"*"+height+"px (minimum)."); };
    },
    validateThumbnailFileDimension(file,width,height){
      let _this = this;
      let result = true;
      if (file) {
          var _URL = window.URL || window.webkitURL;
          let img = new Image();
          var objectUrl = _URL.createObjectURL(file);
          img.onload = function () {
            if (this.width < width || this.height < height) {
              _this.$store.dispatch(
                  "user/setSnack",
                  "Invalid dimensions. Please upload a photo of "+width+"*"+height+"px (minimum)."
                );
                _this.$store.dispatch("user/setType", "error");
                result = false;
            }
            _URL.revokeObjectURL(objectUrl);
          };
          img.src = objectUrl;
          if(!result){
            this.dialog = false;
          }
      }
      return result;
    }
  }
}
